// 序列化时将 bigint 转换为字符串
export const bigintReplacer = (_key: string, value: any) => {
  return typeof value === 'bigint' ? { __type: 'bigint', value: value.toString() } : value;
};

// 反序列化时将标记的字符串转换回 bigint
export const bigintReviver = (_key: string, value: any) => {
  return value && value.__type === 'bigint' ? BigInt(value.value) : value;
};

export const getAppCacheKey = (key: string) => {
  return `audit:${key}`;
};

export class AppStorage {
  public type: 'memory' | 'local' | 'session';

  private memoryStorage: Record<string, any> = {};

  constructor(type: 'memory' | 'local' | 'session') {
    this.type = type;
  }

  getItem<T = any>(key: string): T | undefined {
    if (this.type === 'memory') return this.memoryStorage[key];
    const storage = this.type === 'local' ? localStorage : sessionStorage;
    try {
      const keyWithVersion = getAppCacheKey(key);
      const item = storage.getItem(keyWithVersion);
      if (!item) return undefined;
      return JSON.parse(item, bigintReviver);
    } catch (e) {
      console.error('Failed to get item from storage:', key, e);
      return undefined;
    }
  }

  setItem(key: string, value: any): void {
    if (this.type === 'memory') {
      this.memoryStorage[key] = value;
      return;
    }
    const storage = this.type === 'local' ? localStorage : sessionStorage;
    try {
      const keyWithVersion = getAppCacheKey(key);
      storage.setItem(keyWithVersion, JSON.stringify(value, bigintReplacer));
    } catch (e) {
      console.error('Failed to set item in storage:', key, e);
    }
  }

  removeItem(key: string): void {
    if (this.type === 'memory') {
      delete this.memoryStorage[key];
      return;
    }
    const storage = this.type === 'local' ? localStorage : sessionStorage;
    try {
      const keyWithVersion = getAppCacheKey(key);
      storage.removeItem(keyWithVersion);
    } catch (e) {
      console.error('Failed to remove item from storage:', key, e);
    }
  }

  clear(): void {
    if (this.type === 'memory') {
      this.memoryStorage = {};
      return;
    }
    const storage = this.type === 'local' ? localStorage : sessionStorage;
    try {
      storage.clear();
    } catch (e) {
      console.error('Failed to clear storage:', e);
    }
  }
}

export const memoryCache = new AppStorage('memory');
export const localCache = new AppStorage('local');
export const sessionCache = new AppStorage('session');
export const AppCache = {
  memory: memoryCache,
  local: localCache,
  session: sessionCache,
};
